export default __webpack_public_path__ + "static/media/scut.4bc5c20e.png";